import { PropsWithChildren } from 'react';
import { TableTd } from '@mantine/core';
import classes from './TouringCardTableRowValue.module.css';

export const TouringCardTableRowValue: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return <TableTd className={classes.value}>{children}</TableTd>;
};
